/**
 * Community Links - Centralized config for social platform links
 * Update the URLs below when community channels are ready.
 */

import { siDiscord, siQq, siWechat, siTelegram } from 'simple-icons';

function makeSvg(path: string): string {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="${path}"/></svg>`;
}

export interface CommunityLink {
  platform: string;
  label: string;
  /** URL to open. If empty, the link acts as a trigger (e.g. show QR popup). */
  url: string;
  icon: string;
  /** If set, clicking shows a QR code popup instead of navigating. */
  qrImage?: string;
}

export const COMMUNITY_LINKS: CommunityLink[] = [
  {
    platform: 'discord',
    label: 'Discord',
    url: 'https://discord.gg/PLACEHOLDER',
    icon: makeSvg(siDiscord.path),
  },
  {
    platform: 'qq',
    label: 'QQ群',
    url: 'https://qm.qq.com/PLACEHOLDER',
    icon: makeSvg(siQq.path),
  },
  {
    platform: 'wechat',
    label: '微信',
    url: '',
    icon: makeSvg(siWechat.path),
    // Replace with actual QR code image path, e.g. '/images/wechat-qr.png'
    qrImage: '/images/wechat-qr.png',
  },
  {
    platform: 'telegram',
    label: 'Telegram',
    url: 'https://t.me/PLACEHOLDER',
    icon: makeSvg(siTelegram.path),
  },
];
